import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { getTempCode } from '@api/api'
import { hasUserSessionExpired } from '@util/helpers'
import { TRUSTED_DOMAINS, TRUSTED_DOMAINS_REVERSED, TrustedDomains } from '@constant/SSO'
import ROUTES from '@constant/Routes'

function useLoggedInRedirect() {
  const router = useRouter()
  useEffect(() => {
    if (router.isReady) {
      hasUserSessionExpired().then((tokenExpired) => {
        const jwtIsValid = !tokenExpired
        // FEATURE: SS0
        // IF JWT TOKEN IS VALID AND THE ORIGIN IS OUR OWN DOMAIN THEN
        // REDIRECT THE USER TO SECONDARY DAOMIN WITH TEMP CODE
        if (
          router.query.origin &&
          Object.keys(TRUSTED_DOMAINS).includes(router.query.origin as TrustedDomains) &&
          jwtIsValid
        ) {
          getTempCode().then((data) => {
            window.location.href = `${
              TRUSTED_DOMAINS[router.query.origin as TrustedDomains]
            }/authenticating?tempToken=${data.data.tempToken}&redirectTo=${
              router.query.redirectTo || '/'
            }`
          })
          return
        }

        if (jwtIsValid) {
          router.push(ROUTES.Download)
        }

        // FEATURE: SS0
        // THIS IS TO HANDLE REDIRECTION FOR SECONDARY DOMAIN TO OUR PROMIARY AUTH PAGE ie. workerdefense, riggedeconomy etc.
        if (window.location.origin !== process.env.NEXT_PUBLIC_HERO_APP_URL) {
          const originQuery = `${router.asPath.includes('?') ? '&' : '?'}origin=${
            TRUSTED_DOMAINS_REVERSED[window.location.origin]
          }`
          window.location.href = `${process.env.NEXT_PUBLIC_HERO_APP_URL}${router.asPath}${originQuery}`
        }
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady])
}

export default useLoggedInRedirect
